

































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockRelocationView extends Vue {
  public items: Common.StockRelocation[] = new Array(0);
  public params: Common.StockRelocationQuery = new Common.StockRelocationQuery();
  public importQuery = new Common.ImportQuery('在庫移動','StockRelocation');
  public exportQuery = new Common.ExportQuery('在庫移動',this.params);
  public sortOptions: any = [
    { value: 'State', text:'状態' },    
    { value: 'stockRelocationNo', text: '在庫移動番号' }, 
    { value: 'bookDate', text: '発生日' },    
    { value: 'warehouseIn', text: '入庫倉庫' },
    { value: 'warehouseOut', text: '出庫倉庫' },    
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },    
  ];
  public savingFlag: Common.StockRelocationStatus = Common.StockRelocationStatus.PostWaiting;
  public voucherTypes = Common.voucherTypes;
  @Prop() public stockRelocationNo:string;

  public created() {
    // 検索条件を設定する
    if(this.stockRelocationNo) {
      this.params.stockRelocationNo = this.stockRelocationNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  // 一覧選択時に明細表示ボタンを非活化状態を更新
  public onSelected(index: number, selected: Common.StockRelocation) {
    // 明細表示ボタンの非活化状態を更新
    this.updateDisabledShowItemButton(selected);
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  updateDisabledShowItemButton(stockRelocation:Common.StockRelocation){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetStockRelocationItemQuery();
    query.stockRelocationNo = stockRelocation.stockRelocationNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = res.length == 0;
    });
  }

  // 在庫移動明細一覧を表示
  public showStockRelocationItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.StockRelocation;
    let routeData = this.$router.resolve(String.format('/journal/StockRelocationItem?stockRelocationNo={0}',obj.stockRelocationNo));
    window.open(routeData.href, '_blank');
  }

  public async onCreate(obj: Common.StockRelocation) {
    const workflows = this.$api.formatter.getOptions('workflow_stockRelocation');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //在庫移動明細タブのリロード
    (this.$refs.stockRelocationItems as Components.GrdVoucherItem).onVoucherNoChanged();       
  }

  //在庫選択画面を表示して在庫移動を実行する(追加モード)
  public showStockBalance:boolean = false;
  public onAddItems(item : Common.StockRelocation){
    //在庫移動メニューを起動する
    var stockBalance = this.$refs.stockBalance as Components.StockBalance;
    stockBalance.asrBookDate = item.bookDate;
    stockBalance.asrWarehouseOut = item.warehouseOut;
    stockBalance.asrWarehouseIn = item.warehouseIn;
    stockBalance.asrPic =item.pic;
    stockBalance.asrWorkflowId = item.workflowId;
    stockBalance.asrClosingDate = item.bookDate;
    stockBalance.asrSegment = item.segment;
    stockBalance.asrStockRelocation = item;
    stockBalance.asrUpdatedHandler= this.onComplete;
    stockBalance.showStockRelocationDialog();
  }
  public onComplete() {
    // 在庫移動子画面で保存が成功した場合の後続処理
    // ①在庫選択画面を非表示にする
    // ②明細タブをリロードする        
    this.showStockBalance = false;
    (this.$refs.stockRelocationItems as Components.GrdVoucherItem).onVoucherNoChanged();
  }
}
